// @ts-nocheck
export const localeCodes =  [
  "de-DE",
  "de-AT",
  "pl-PL",
  "pt-PT",
  "es-ES",
  "it-IT",
  "nl-NL",
  "cs-CZ",
  "sk-SK",
  "hu-HU",
  "sl-SI",
  "hr-HR",
  "ro-RO",
  "bg-BG"
]
export const localeLoaders = {
  "de-DE": [
    {
      key: "locale_de_45DE_46json_475226ce",
      load: () => import("#nuxt-i18n/475226ce" /* webpackChunkName: "locale_de_45DE_46json_475226ce" */),
      cache: true
    }
  ],
  "de-AT": [
    {
      key: "locale_de_45AT_46json_4a380f1a",
      load: () => import("#nuxt-i18n/4a380f1a" /* webpackChunkName: "locale_de_45AT_46json_4a380f1a" */),
      cache: true
    }
  ],
  "pl-PL": [
    {
      key: "locale_pl_45PL_46json_850f3b1f",
      load: () => import("#nuxt-i18n/850f3b1f" /* webpackChunkName: "locale_pl_45PL_46json_850f3b1f" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_254580df",
      load: () => import("#nuxt-i18n/254580df" /* webpackChunkName: "locale_pt_45PT_46json_254580df" */),
      cache: true
    }
  ],
  "es-ES": [
    {
      key: "locale_es_45ES_46json_74820c60",
      load: () => import("#nuxt-i18n/74820c60" /* webpackChunkName: "locale_es_45ES_46json_74820c60" */),
      cache: true
    }
  ],
  "it-IT": [
    {
      key: "locale_it_45IT_46json_98997300",
      load: () => import("#nuxt-i18n/98997300" /* webpackChunkName: "locale_it_45IT_46json_98997300" */),
      cache: true
    }
  ],
  "nl-NL": [
    {
      key: "locale_nl_45NL_46json_b117aa10",
      load: () => import("#nuxt-i18n/b117aa10" /* webpackChunkName: "locale_nl_45NL_46json_b117aa10" */),
      cache: true
    }
  ],
  "cs-CZ": [
    {
      key: "locale_cs_45CZ_46json_eadf06a1",
      load: () => import("#nuxt-i18n/eadf06a1" /* webpackChunkName: "locale_cs_45CZ_46json_eadf06a1" */),
      cache: true
    }
  ],
  "sk-SK": [
    {
      key: "locale_sk_45SK_46json_46c8804e",
      load: () => import("#nuxt-i18n/46c8804e" /* webpackChunkName: "locale_sk_45SK_46json_46c8804e" */),
      cache: true
    }
  ],
  "hu-HU": [
    {
      key: "locale_hu_45HU_46json_0fdbd1f0",
      load: () => import("#nuxt-i18n/0fdbd1f0" /* webpackChunkName: "locale_hu_45HU_46json_0fdbd1f0" */),
      cache: true
    }
  ],
  "sl-SI": [
    {
      key: "locale_sl_45SI_46json_26d2b3f1",
      load: () => import("#nuxt-i18n/26d2b3f1" /* webpackChunkName: "locale_sl_45SI_46json_26d2b3f1" */),
      cache: true
    }
  ],
  "hr-HR": [
    {
      key: "locale_hr_45HR_46json_c94401bc",
      load: () => import("#nuxt-i18n/c94401bc" /* webpackChunkName: "locale_hr_45HR_46json_c94401bc" */),
      cache: true
    }
  ],
  "ro-RO": [
    {
      key: "locale_ro_45RO_46json_daebe12d",
      load: () => import("#nuxt-i18n/daebe12d" /* webpackChunkName: "locale_ro_45RO_46json_daebe12d" */),
      cache: true
    }
  ],
  "bg-BG": [
    {
      key: "locale_bg_45BG_46json_135c050f",
      load: () => import("#nuxt-i18n/135c050f" /* webpackChunkName: "locale_bg_45BG_46json_135c050f" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/54cf104a" /* webpackChunkName: "config_i18n_46config_46ts_54cf104a" */)
]
export const normalizedLocales = [
  {
    code: "de-DE",
    label: "German",
    iso: "de-DE",
    language: undefined
  },
  {
    code: "de-AT",
    label: "German",
    iso: "de-AT",
    language: undefined
  },
  {
    code: "pl-PL",
    label: "Poland",
    iso: "pl-PL",
    language: undefined
  },
  {
    code: "pt-PT",
    label: "Portugal",
    iso: "pt-PT",
    language: undefined
  },
  {
    code: "es-ES",
    label: "Spain",
    iso: "es-ES",
    language: undefined
  },
  {
    code: "it-IT",
    label: "Italy",
    iso: "it-IT",
    language: undefined
  },
  {
    code: "nl-NL",
    label: "Netherlands",
    iso: "nl-NL",
    language: undefined
  },
  {
    code: "cs-CZ",
    label: "Czech Republic",
    iso: "cs-CZ",
    language: undefined
  },
  {
    code: "sk-SK",
    label: "Slovakia",
    iso: "sk-SK",
    language: undefined
  },
  {
    code: "hu-HU",
    label: "Hungary",
    iso: "hu-HU",
    language: undefined
  },
  {
    code: "sl-SI",
    label: "Slovenia",
    iso: "sl-SI",
    language: undefined
  },
  {
    code: "hr-HR",
    label: "Croatia",
    iso: "hr-HR",
    language: undefined
  },
  {
    code: "ro-RO",
    label: "Romania",
    iso: "ro-RO",
    language: undefined
  },
  {
    code: "bg-BG",
    label: "Bulgaria",
    iso: "bg-BG",
    language: undefined
  }
]
/** client **/

/** client-end **/